import { ChangeEvent } from "react"
import styled from "styled-components"

import { useLazyGetCitiesQuery, useLazyGetStatesQuery } from "store/api/dictionaryApi"

import ModalSectionTitle from "components/common/ModalSectionTitle/ModalSectionTitle"
import { InputNew } from "components/form/InputNew"
import { InputPhone } from "components/form/InputPhone"
import { SelectDynamic } from "components/form/SelectDynamic"

import { ClientValues, SectionTitle } from "./formValues"

const FieldRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 30px;
  padding-bottom: 8px;
`

const FieldItem = styled.div`
  flex: 1 0 calc(50% - 15px);
  min-width: 200px;

  && > * {
    margin-bottom: 0;
  }
`

const FieldLabel = styled.h4`
  font-size: 0.75rem;
  text-transform: uppercase;
  color: var(--text-primary);
  margin: 0 0 4px 0;
`

interface Props {
  values: ClientValues
  error: { field: string; message: string }
  setValues: React.Dispatch<React.SetStateAction<ClientValues>>
}

export const CustomerDetailsSection = ({ values, error, setValues }: Props) => {
  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget
    setValues(prevState => ({ ...prevState, [name]: value }))
  }

  return (
    <>
      <SectionTitle>
        <ModalSectionTitle title="Customer details" />
      </SectionTitle>
      <FieldRow>
        <FieldItem>
          <FieldLabel>Customer name</FieldLabel>
          <InputNew
            placeholder="Enter"
            name="homeowner_name"
            value={values.homeowner_name}
            onChange={onInputChange}
            errorMessage={error.field === "homeowner_name" ? error.message : ""}
          />
        </FieldItem>
        <FieldItem>
          <FieldLabel>Property address</FieldLabel>
          <InputNew
            placeholder="Street address"
            name="address1"
            value={values.address1}
            onChange={onInputChange}
            errorMessage={error.field === "address1" ? error.message : ""}
          />
        </FieldItem>
        <FieldItem>
          <FieldLabel>State</FieldLabel>
          <SelectDynamic
            placeholder="Select state"
            name="state"
            valueName="id"
            labelName="name"
            values={values.state}
            useLazyQuery={useLazyGetStatesQuery}
            queryParams={{ country_id: 1 }}
            onChange={state => setValues(prevState => ({ ...prevState, state, city: [] }))}
            errorMessage={error.field === "state" ? error.message : ""}
          />
        </FieldItem>
        <FieldItem>
          <FieldLabel>City</FieldLabel>
          <SelectDynamic
            placeholder="Select city"
            name="city"
            valueName="id"
            labelName="name"
            values={values.city}
            useLazyQuery={useLazyGetCitiesQuery}
            queryParams={{ state_id: values.state[0]?.value != null ? `${values.state[0].value}` : undefined }}
            onChange={city => setValues(prevState => ({ ...prevState, city }))}
            errorMessage={error.field === "city" ? error.message : ""}
          />
        </FieldItem>
        <FieldItem>
          <FieldLabel>Email (Optional)</FieldLabel>
          <InputNew
            placeholder="Enter"
            name="email"
            value={values.email}
            onChange={onInputChange}
            errorMessage={error.field === "email" ? error.message : ""}
          />
        </FieldItem>
        <FieldItem>
          <FieldLabel>Phone</FieldLabel>
          <InputPhone
            placeholder="Enter"
            name="phone"
            value={values.phone}
            onChange={value => setValues(prevState => ({ ...prevState, phone: value }))}
            errorMessage={error.field === "phone" ? error.message : ""}
          />
        </FieldItem>
      </FieldRow>
    </>
  )
}
